// extracted by mini-css-extract-plugin
module.exports = {"container":"Calculator_container__RxEhP","background":"Calculator_background__M27VG"};